import isUndefined from 'lodash/isUndefined';

import {
    trackEventFromState,
    trackEventFromStateOnPageUnload,
} from '@eb/site-analytics';

import {
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK,
} from '@eb/social-login-facebook';

import {
    GA_SIWA_EMAIL_ALREADY_EXISTS,
    GA_HIDDEN_EMAIL,
    GA_SHOWED_EMAIL,
    GA_EMAIL_NOT_FOUND,
    GA_SIWA_ACCOUNTS_LINK_OPTION,
    GA_LINK_ACCOUNT_OPTION,
    GA_SIWA_ACCOUNT_CREATED,
    GA_SIWA_ACCOUNT_CREATED_FAILED,
    GA_TOKEN_EXPIRED,
    GA_LOGIN_CATEGORY,
    GA_LOGIN_CLICKED,
    GA_SIGNUP_CLICKED,
    GA_LOGIN_SUCCESSFUL,
    GA_PASSWORD_INCORRECT,
    GA_PASSWORD_VIEWED,
    GA_PASSWORD_FORGOTTEN,
    GA_PASSWORD_FORGOTTEN_MAIL_FAILED,
    GA_PASSWORD_FORGOTTEN_MAIL_SENT,
    GA_PASSWORD_RESETED,
    GA_PASSWORD_RESETED_FAILED,
    GA_COMMUNITY_GUIDELINES_CLICKED,
    GA_PRIVACY_POLICY_CLICKED,
    GA_TERMS_OF_SERVICE_CLICKED,
    GA_USE_ANOTHER_ACCOUNT_CLICKED,
    GA_MAGIC_LINK_CLICKED,
    GA_MAGIC_LINK_SENT,
    GA_MAGIC_LINK_FAILED,
    GA_MAGIC_LINK_CONFIRMATION_CLOSED,
    GA_ACCOUNT_LINKED,
    GA_ACCOUNT_LINK_FAILED,
    GA_ACCOUNT_LOGIN_NOT_LINKED,
    GA_ACCOUNT_LINK_CONFIRMATION_CLOSED,
    GA_EVENTBRITE,
} from '../constants/analytics';

import {
    EVENTBRITE_PROVIDER,
    GA_AUTH_CATEGORY,
    GA_LOGIN_INVALID_PASSWORD,
    GA_APPLE_LOGIN_BUTTON_CLICKED_EVENT,
    GA_FB_LOGIN_BUTTON_CLICKED_EVENT,
    GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB,
    GA_COMUNITY_GUIDELINES_CLICKED as OLD_GA_COMUNITY_GUIDELINES_CLICKED,
    GA_PRIVACY_POLICY_CLICKED as OLD_GA_PRIVACY_POLICY_CLICKED,
    GA_TOS_CLICKED as OLD_GA_TOS_CLICKED,
    GA_GET_STARTED_CLICKED,
    GA_FORGOT_PASSWORD_EVENT,
    GA_EXISTING_ACCT_LABEL,
    GA_EDIT_EMAIL_EVENT,
} from '../constants/newIndex';

// SIWA flow metrics

/****************************
 * User doesn't share email *
 ****************************/

// User has an EB account
export const trackSIWA_LookUpSuccessWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_HIDDEN_EMAIL,
    });
};

// User has an EB account, enters wrong password
export const trackSIWA_WrongPassword = (state) => {
    trackEventFromState(state, {
        action: GA_LOGIN_INVALID_PASSWORD,
        category: GA_AUTH_CATEGORY,
        label: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    });
};

// User has an EB account, successfuly link their account
// export const trackSuccessfullyLinkAccountsWithExistingEBAccount = (
//     sourceProvider,
// ) => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

// User doesn't has an EB account, enters an email that isn't an EB account
export const trackSIWA_EmailNotFound = (state) => {
    trackEventFromState(state, {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_EMAIL_NOT_FOUND,
    });
};

// User doesn't has an EB account, enters an email that isn't an EB account, successfuly link their account
// export const trackSuccessfullyLinkAccountsWithoutEBAccount = (
//     sourceProvider,
// ) => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

// User doesn't has an EB account, enters an email that isn't an EB account, wrong password - Possible?
// export const trackWrongPasswordOnLinkAccountsWithoutEBAccount = (
//     sourceProvider,
// ) => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_LOGIN_INVALID_PASSWORD,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

// track accounts linked when user hide the email but add EB account on page load
export const trackSIWA_AccountsLinkOptionWithHiddenEmail = (hidden) => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_ACCOUNTS_LINK_OPTION,
        category: GA_AUTH_CATEGORY,
        label: hidden ? GA_HIDDEN_EMAIL : GA_SHOWED_EMAIL,
    });
};

// track account created when user hide his email and doesn't have an EB account
export const trackSIWA_AccountCreatedWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_ACCOUNT_CREATED,
        category: GA_AUTH_CATEGORY,
        label: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    });
};

// track when user wants to link his account with an EB account
export const trackSIWA_AccountLinkAttemptWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_LINK_ACCOUNT_OPTION,
    });
};

/****************************
 *     User share email     *
 ****************************/

// track successfuly login with showed email
export const trackSIWA_LookUpSuccessWithEmail = () => (dispatch, getState) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_SHOWED_EMAIL,
    });
};

/*
 * User enter wrong password for his EB account
 */
// export const trackSIWA_WrongPasswordWithEBAccount = (sourceProvider) => (
//     dispatch,
//     getState,
// ) => {
//     trackEventFromState(getState(), {
//         action: GA_LOGIN_INVALID_PASSWORD,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

/*
 * User successfuly link their account
 */
// export const trackSIWA_LinkAccountWithEBAccount = (sourceProvider) => (
//     dispatch,
//     getState,
// ) => {
//     trackEventFromState(getState(), {
//         action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

/*
 * User enter an email that isn't an EB account
 */
// export const trackSIWAEmailNotFound = () => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_SIWA_EMAIL_ALREADY_EXISTS,
//         category: GA_AUTH_CATEGORY,
//         label: GA_EMAIL_NOT_FOUND,
//     });
// };

export const trackSIWA_errorOnNewUser = (state, label) => {
    trackEventFromState(state, {
        action: GA_SIWA_ACCOUNT_CREATED_FAILED,
        category: GA_AUTH_CATEGORY,
        label,
    });
};

/****************************
 *     General cases     *
 ****************************/

// Track when token expired
export const trackTokenExpired = (state) => {
    trackEventFromState(state, {
        action: GA_TOKEN_EXPIRED,
        category: GA_AUTH_CATEGORY,
        label: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    });
};

/****************************************
 * *GA TRACKING FOR LOGIN VERSION 2.X.X *
 ****************************************/

export const trackLoginClicked = ({
    sourceProvider,
    stateFromProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    // old flow metrics
    let action = '';
    if (!launchAuthenticationRefactor) {
        if (isUndefined(sourceProvider)) {
            action = GA_GET_STARTED_CLICKED;
        } else if (sourceProvider === EVENTBRITE_PROVIDER) {
            action = GA_LOGIN_CLICKED;
        } else if (
            sourceProvider === SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK
        ) {
            action = GA_FB_LOGIN_BUTTON_CLICKED_EVENT;

            if (stateFromProvider && stateFromProvider.status === 'unknown') {
                action = GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB;
            }
        } else if (sourceProvider === SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE) {
            action = GA_APPLE_LOGIN_BUTTON_CLICKED_EVENT;
        }
    }

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor ? GA_LOGIN_CLICKED : action,
        label: !isUndefined(sourceProvider) ? sourceProvider : GA_EVENTBRITE,
    });
};

export const trackSignUpClicked = (state) => {
    trackEventFromState(state, {
        category: GA_LOGIN_CATEGORY,
        action: GA_SIGNUP_CLICKED,
    });
};

export const trackLoginSuccessful = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_LOGIN_SUCCESSFUL,
        label: sourceProvider,
    });
};

export const trackPasswordIncorrect = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PASSWORD_INCORRECT
            : GA_LOGIN_INVALID_PASSWORD,
        label: !isUndefined(sourceProvider) ? sourceProvider : GA_EVENTBRITE,
    });
};

export const trackPasswordViewed = ({ sourceProvider, state }) => {
    trackEventFromState(state, {
        category: GA_LOGIN_CATEGORY,
        action: GA_PASSWORD_VIEWED,
        label: !isUndefined(sourceProvider) ? sourceProvider : GA_EVENTBRITE,
    });
};

export const trackPasswordForgotten = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PASSWORD_FORGOTTEN
            : GA_FORGOT_PASSWORD_EVENT,
        label: sourceProvider,
    });
};

export const trackPasswordForgottenMailFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_PASSWORD_FORGOTTEN_MAIL_FAILED,
        label: errorMessage,
    });
};
export const trackPasswordForgottenMailSent = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_PASSWORD_FORGOTTEN_MAIL_SENT,
        label: sourceProvider,
    });
};

export const trackPasswordReseted = ({
    sourceProvider,
    state,
    setPasswordEvent,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PASSWORD_RESETED
            : setPasswordEvent,
        label: !isUndefined(sourceProvider) ? sourceProvider : GA_EVENTBRITE,
    });
};

export const trackPasswordResetedFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_PASSWORD_RESETED_FAILED,
        label: errorMessage,
    });
};

export const trackCommunityGuidelinesClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_COMMUNITY_GUIDELINES_CLICKED
            : OLD_GA_COMUNITY_GUIDELINES_CLICKED,
    });
};

export const trackPrivacyPolicyClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PRIVACY_POLICY_CLICKED
            : OLD_GA_PRIVACY_POLICY_CLICKED,
    });
};

export const trackTermsOfServiceClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_TERMS_OF_SERVICE_CLICKED
            : OLD_GA_TOS_CLICKED,
    });
};

export const trackUseAnotherAccountClicked = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_USE_ANOTHER_ACCOUNT_CLICKED
            : GA_EDIT_EMAIL_EVENT,
        label: !isUndefined(sourceProvider) ? sourceProvider : GA_EVENTBRITE,
    });
};

export const trackMagicLinkClicked = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_CLICKED,
        label: sourceProvider,
    });
};

export const trackMagicLinkSent = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_SENT,
        label: sourceProvider,
    });
};

export const trackMagicLinkFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_FAILED,
        label: errorMessage,
    });
};

export const trackMagicLinkConfirmationClosed = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_CONFIRMATION_CLOSED,
    });
};

export const trackAccountLinked = ({
    sourceProvider,
    state,
    linked = true,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: linked ? GA_ACCOUNT_LINKED : GA_ACCOUNT_LOGIN_NOT_LINKED,
        label: sourceProvider,
    });
};

export const trackAccountLinkFailed = ({ errorDescription, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_ACCOUNT_LINK_FAILED,
        label: errorDescription,
    });
};

export const trackAccountLinkConfirmationClosed = ({ label, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_ACCOUNT_LINK_CONFIRMATION_CLOSED,
        label,
    });
};

/** END GA TRACKING FOR LOGIN VERSION 2.X.X */
